/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges, OnInit} from '@angular/core';
import * as _ from 'lodash';

import {LINE_ITEM_EXECUTION_STATE} from "../common/constants/resource-constants";
import {interpolateWarning} from '../common/directives/error/interpolate-warnings-filter';
import {TranslateModule} from '@ngx-translate/core';
import {APP_SHARED} from '../common/app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED, TranslateModule],
  selector: 'line-item-execution-label',
  template: `
    <span class="unbrokenText">
      <span *ngIf="executionState && !executionStateEndedReason"
            class="label" [ngClass]="labelClass[executionState]">{{ ('lineItem.executionState.' + executionState) | ogTranslate }}</span>
      <span *ngIf="executionStateEndedReason && (deliveryPercentage || deliveryPercentage === 0)"
            class="label" [ngClass]="deliveryHealthLabel(deliveryPercentage)">{{ ('lineItem.executionStateEndedReason.' + executionStateEndedReason) | ogTranslate }}: {{ deliveryPercentage }}%</span>
      <span *ngIf="executionStateEndedReason && !deliveryPercentage && deliveryPercentage !== 0"
            class="label" [ngClass]="labelClass[executionState]">{{ ('lineItem.executionStateEndedReason.' + executionStateEndedReason) | ogTranslate }}</span>
      <info-icon
        *ngIf="warningsOutput && warnings?.length > 0" [text]="warningsOutput" placement="bottom"></info-icon>
    </span>
  `
})
export class LineItemExecutionLabelComponent implements OnInit, OnChanges {
  labelClass: Record<string, string> = {};
  warningsOutput: string = null;
  @Input() executionState: string;
  @Input() executionStateEndedReason: string;
  @Input() deliveryPercentage: number;
  @Input() objectives: any;
  @Input() warnings: any;
  @Input() showInfo: boolean;

  constructor() {
  }

  ngOnInit(): void {
    this.labelClass[LINE_ITEM_EXECUTION_STATE.notReady] = 'label-danger';
    this.labelClass[LINE_ITEM_EXECUTION_STATE.ready] = 'label-warning';
    this.labelClass[LINE_ITEM_EXECUTION_STATE.pausedOrReserved] = 'label-warning';
    this.labelClass[LINE_ITEM_EXECUTION_STATE.running] = 'label-success';
    this.labelClass[LINE_ITEM_EXECUTION_STATE.ended] = 'label-info';
    this.updateWarnings();
  }

  ngOnChanges(): void {
    this.updateWarnings();
  }

  deliveryHealthLabel(deliveryPercentage: number): string {
    if (deliveryPercentage < 60) {
      return 'label-danger';
    }
    if (deliveryPercentage < 95) {
      return 'label-warning';
    }
    return 'label-info';
  }

  private updateWarnings(): void {
    if (!this.showInfo) {
      this.warningsOutput = null;
      return;
    }
    this.warningsOutput = '<ul>';
    _.forEach(this.warnings || [], (warning) => {
      this.warningsOutput += '<li>' + interpolateWarning(warning) + '</li>';
    });
    this.warningsOutput += '</ul>';
  }
}
